import { render, staticRenderFns } from "./SupplierKpiHistoryChart.vue?vue&type=template&id=d42a1976&scoped=true"
import script from "./SupplierKpiHistoryChart.vue?vue&type=script&lang=js"
export * from "./SupplierKpiHistoryChart.vue?vue&type=script&lang=js"
import style0 from "./SupplierKpiHistoryChart.vue?vue&type=style&index=0&id=d42a1976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d42a1976",
  null
  
)

export default component.exports